import React from 'react';
import { Empty, Spin } from 'antd';
import InfoCard from '../../common/InfoCard/InfoCard';
import useCardPagination from '../../../../../hooks/useCardPagination';
import styles from './RelatedObjects.module.scss';
import useFilterRalated from '../../../hooks/useFilterRalated';
import RelatedObjectsFilter from '../RelatedObjectsFilter/RelatedObjectsFilter';
import useCombinedFilter from '../../..//hooks/useCombinedFilter';
import RelatedRequest from '../RelatedRequest';

const RelatedObjects = ({
  data = [],
  cardSize = 5,
  className,
  loading = false,
  onItemClick,
}) => {
  const { stageFilter, warFilter } = useCombinedFilter(data);

  const {
    filteredDate,
    handleChangeStageFilter,
    handleChangeWarrantyFilter,
    selectedStage,
    selectedWar,
  } = useFilterRalated(data);

  const { shownItems, pagination } = useCardPagination(filteredDate, cardSize);

  return (
    <InfoCard
      title={
        <div className={styles.title}>
          Связанные объекты
          <RelatedObjectsFilter
            handleChangeStageFilter={handleChangeStageFilter}
            stageFilter={stageFilter}
            warFilter={warFilter}
            selectedStageFilter={selectedStage}
            selectedWarFilter={selectedWar}
            handleChangeWarrantyFilter={handleChangeWarrantyFilter}
          />
        </div>
      }
      action={data.length > cardSize ? pagination : undefined}
      className={className}
    >
      <Spin spinning={loading}>
        {data.length > 0 ? (
          <ul className={styles.list}>
            {shownItems.map((item) => {
              return (
                <RelatedRequest
                  key={item.id}
                  request={item}
                  onItemClick={onItemClick}
                />
              );
            })}
          </ul>
        ) : (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        )}
      </Spin>
    </InfoCard>
  );
};

export default RelatedObjects;
